import React from "react";
import { Icon, PlainButton, Tag } from "@culturehq/components";

import { t, Trans } from "app/utils";
import PromptIcon from "components/stories/PromptIcon";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import SubPromptModal from "./SubPromptModal";

const StoryPromptOption = ({ index, onDelete, onUpdate, prompt }) => {
  const onAccept = () => onDelete(index);

  const mediaType = () => {
    switch (prompt.allowedTypes) {
      case "all":
        return t("Images and Videos");
      case "just_images":
        return t("Images Only");
      case "just_videos":
        return t("Videos Only");
      default:
        return "N/A";
    }
  };

  const handleUpdate = storyQuestion => {
    onUpdate({ ...storyQuestion, index });
  };

  return (
    <div className="row chart-row" data-id={prompt.id || prompt.key}>
      <div className="p-0 sortable-column">
        <div className="sortable__drag-handler" />
      </div>
      <div className="col-sm-7 column prompt-title p-0">
        <PromptIcon allowedTypes={prompt.allowedTypes} />
        {prompt.question}
        {prompt?.status === "paused" && (
          <Tag className="ChildPrompts__Tag" color="red"><Trans>Paused</Trans></Tag>
        )}
        {prompt?.status === "hidden" && (
          <Tag className="ChildPrompts__Tag" color="red"><Trans>Hidden</Trans></Tag>
        )}
        {prompt?.status === "archived" && (
          <Tag className="ChildPrompts__Tag" color="red"><Trans>Archived</Trans></Tag>
        )}
      </div>
      <div className="col-sm-2 column">{mediaType()}</div>
      <div className="col-sm-2 column actions align-self-end">
        <ChqModalConfirmDelete
          onAccept={onAccept}
          trigger={onTrigger => (
            <PlainButton aria-label={`${t("Delete")} ${prompt.question} ${t("option")}`} className="link action pull-right" onClick={onTrigger}>
              <Icon icon="trash-a" />
            </PlainButton>
          )}
        >
          <Trans>Are you sure you want to delete this option?</Trans>
        </ChqModalConfirmDelete>
        <SubPromptModal onUpdate={handleUpdate} storyQuestion={prompt}>
          {onTrigger => (
            <PlainButton className="Subprompt-Edit_Btn link action pull-right" onClick={onTrigger}>
              <Icon icon="edit" />
            </PlainButton>
          )}
        </SubPromptModal>
      </div>
    </div>
  );
};

export default StoryPromptOption;
